import React from 'react';

export const BedsIcon = props => (
  <svg viewBox="0 0 23 18" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g stroke="#545D69" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <path d="M9.208 4.143h1.133v8.347H.58l2.374-8.347h1.142" />
      <path
        d="M10.341 15.62c0 .577-.285 1.043-.637 1.043H1.216c-.352 0-.637-.466-.637-1.043v-3.13h9.762v3.13h0zM2.162 6.925h8.164M3.745 5.534l.528-2.086h4.749v2.086z"
        strokeLinecap="round"
      />
      <path
        d="M2.954 4.143V2.404c0-.575.354-1.043.791-1.043H9.55c.436 0 .791.468.791 1.043v1.74M2.162 16.663v.696M8.758 16.78v.694"
        strokeLinecap="round"
      />
      <g>
        <path d="M13.212 4.143H12.08v8.347h9.762l-2.374-8.347h-1.143" />
        <path
          d="M12.08 15.62c0 .577.285 1.043.636 1.043h8.489c.352 0 .636-.466.636-1.043v-3.13H12.08v3.13h0zM20.258 6.925h-8.164M18.675 5.534l-.527-2.086h-4.75v2.086z"
          strokeLinecap="round"
        />
        <path
          d="M19.467 4.143V2.404c0-.575-.354-1.043-.792-1.043h-5.804c-.437 0-.791.468-.791 1.043v1.74M20.258 16.663v.696M13.662 16.78v.694"
          strokeLinecap="round"
        />
      </g>
    </g>
  </svg>
);
